<template>
  <b-list-group-item>
    <b-row>
      <b-col>
        <router-link :to="{ name: 'Massima', params: { idMassima: premassima.id }}">
          <p class="font-weight-bold" style="font-size: larger">{{premassima.sentenzaTitolo}}</p>
        </router-link>
      </b-col>
    </b-row>
    <b-row>
        <b-col cols="12">
            <b>Materia: {{premassima.sentenzaMateria}}</b><br/>
            <b>Sottomateria: {{premassima.sentenzaSottoMateria}}</b>
        </b-col>
        <b-col cols="6" class="text-left mt-2">
          <router-link :to="{ name: 'Profilo', params: { codFisc: premassima.codFisc } }" class="text-decoration-none">
              <img :src="imgLink" width="20" />&nbsp;&nbsp;
              <b class="text-uppercase">{{premassima.avvocato}}</b>
          </router-link>
        </b-col>
        <b-col cols="6" class="text-right mt-2">
            <small class="text-muted">Pubblicato il {{data}}</small>
        </b-col>
        <b-col class="text-justify mt-4">
            <div v-html="premassima.premassima"></div>
        </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script>
import service from '../../services/service.js';
import utils from '../../services/utils.js';

export default {
  data () {
    return {
        data: '',
        imgLink: ''
    }
  },
  props: {
    premassima: {
      id: String,
      sentenzaTitolo: String,
      testo: String,
      premassima: String,
      avvocato: String,
      codFisc: String,
      sentenzaMateria: String,
      sentenzaSottoMateria: String,
      dataInserimento: String
    }
  },
  async created() {
    this.data = utils.formatDate(new Date(this.premassima.dataInserimento));
    this.imgLink = utils.getAvatarUrl(this.premassima.codFisc);
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Pubblica/Premassima.vue